var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHkd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_1233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0652 15.13C21.6107 17.0205 20.8031 16.66 20.4068 18.3087C18.0722 17.7474 16.6343 15.3997 17.1957 13.065C17.7568 10.7304 20.1047 9.29255 22.4393 9.85387C21.6466 13.1513 22.4718 13.4391 22.0652 15.13Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0072 16.531C17.6648 17.5474 17.0723 18.2042 18.5178 19.0907C17.2625 21.1377 14.5855 21.7795 12.5385 20.5242C10.4915 19.269 9.84958 16.5919 11.1049 14.5449C13.996 16.3177 14.5245 15.6219 16.0072 16.531Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4671 22.7256C16.9461 21.4633 17.3874 22.2297 18.6771 21.1289C20.2361 22.9552 20.0193 25.6996 18.193 27.2586C16.3666 28.8176 13.6222 28.6005 12.0635 26.7743C14.6427 24.5725 14.1442 23.8546 15.4671 22.7256Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1918 25.1534C20.4481 23.3567 21.3134 23.1736 20.665 21.607C22.8837 20.6888 25.4268 21.743 26.3451 23.9617C27.2633 26.1803 26.2089 28.7234 23.9903 29.6417C22.6936 26.5081 21.857 26.7604 21.1918 25.1534Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2699 20.4588C23.3314 20.6109 23.4245 19.7312 21.7342 19.8639C21.5465 17.4702 23.3351 15.3772 25.7289 15.1893C28.1227 15.0018 30.2156 16.7903 30.4033 19.1842C27.0223 19.4493 27.0036 20.3229 25.2699 20.4588Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_1233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkd);
export default __webpack_public_path__ + "static/media/HKD.c14f87f413ea6630af0925bc73508dad.svg";
export { ForwardRef as ReactComponent };